<template>
  <div style="min-height: 200px">
    <up-next-task-filter></up-next-task-filter>

    <app-loading-section
      :loading="isLoading"
      :count="tasks.length"
      :heading="taskFilterEmptyMessage"
    >
      <up-next-task-list
        :tasks="tasks"
        :empty-message="taskFilterEmptyMessage"
      ></up-next-task-list>

      <button-default
        v-if="nextPageUrl"
        class="my-100"
        is-outlined
        :async-click="loadMoreTasks"
      >Show More
      </button-default>
    </app-loading-section>
  </div>
</template>

<script>
import UpNextTaskFilter from './components/UpNextTaskFilter';
import UpNextTaskList from "./components/UpNextTaskList";
import api from "../../api";

export default {
  name: 'UpNextTasksMobileTab',
  components: {
    UpNextTaskList,
    UpNextTaskFilter
  },
  data() {
    return {
      isLoading: true,
      nextPageUrl: null,
      requiredFilterEnum: {
        'NoFilter': {
          value: 0,
          label: 'No Filter'
        },
        'No': {
          value: 1,
          label: 'No'
        },
        'Yes': {
          value: 2,
          label: 'Yes'
        }
      }
    }
  },
  computed: {
    queryFilter() {
      return this.$store.getters["upNext/incompleteTasksQueryFilter"]
    },
    taskFilterEmptyMessage() {
      let users = [];
      const filters = this.$store.state.upNext.filters.tasks;
      const requiredEnum = this.$store.state.upNext.requiredFilterEnum;

      filters.users.forEach(filterUserId => {
        const user = this.$store.getters.activeUsers.find(user => user.id === filterUserId);
        if (user) {
          users.push(user.first_name);
        }
      });

      let requiredLabel = "";
      if (filters.required === requiredEnum.No.value) requiredLabel = "that isn't required to change status";
      if (filters.required === requiredEnum.Yes.value) requiredLabel = "that is required to change status";

      if (users.length !== 0) {
        return `There are no tasks for ${users.toString().replace(/,/g, ", ")} ${requiredLabel}`;
      }

      return `There are no tasks yet ${requiredLabel}`;
    },
    tasks() {
      return this.$store.getters["upNext/incompleteTasks"];
    }
  },
  created() {
    api.clientStore.getTasks(this.$store.getters.market.id, this.queryFilter).then(res => {
      this.$store.commit('setRoot', { store: 'upNext', prop: 'incompleteTasks', data: res.data.data });
      this.nextPageUrl = res.data.links.next
      this.isLoading = false;
    });
  },
  methods: {
    loadMoreTasks() {
      return api.custom.get(`${this.nextPageUrl}&${this.queryFilter}`)
        .then(res => {
          const copy = this.$utils.clone(this.tasks);
          const newTasks = [...copy, ...res.data.data];

          this.$store.commit("setRoot", {store: "upNext", prop: "incompleteTasks", data: newTasks});
          this.nextPageUrl = res.data.links.next;
        })
    },
  }
}
</script>
